import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { UpdateCustomerProps } from 'app/services/admin.service';
import { AgencyCounty, AgencyInfoService } from 'app/services/agency-info.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { GivCustomerInitInfo } from 'app/services/agency-info.service';
import { DomainService } from 'app/services/domain.service';
import { NagService } from 'app/services/nag.service';
import { UserService } from 'app/services/user.service';

export interface AddSubAgencyModalOutput {
	name: string;
	desc: string;
	pw: string;
	adminEmail: string;
	cusProps: UpdateCustomerProps;
}
@Component({
  selector: 'app-add-sub-agency-modal',
  templateUrl: './add-sub-agency-modal.component.html',
  styleUrls: ['./add-sub-agency-modal.component.css']
})
export class AddSubAgencyModalComponent implements OnInit {

	public shortName: string;
	public longName: string;
	public adminEmail: string;
	public password: string;
	public confirmPassword: string;

	givInfo: GivCustomerInitInfo = {
		nguidPattern: {
			layerType: false
		},
		// neighboringCounties: []
	}
	givBdryCateList: {
		prop: string;
		name: string;
	}[] = [];
	countyList: AgencyCounty[] = [];
	constructor(
		public dialogRef: MatDialogRef<AddSubAgencyModalComponent>,
		// private attrIndexService: AttrIndexService,
		// private domainService: DomainService,
		// private nagService: NagService,
		private agencyInfoService: AgencyInfoService,
		private userService: UserService
	) { }

	create() {
		if (this.shortName && this.adminEmail && this.password && this.confirmPassword && this.password === this.confirmPassword) {
			const data: AddSubAgencyModalOutput = {
				name: this.shortName,
				desc: this.longName,
				pw: this.password,
				adminEmail: this.adminEmail,
				cusProps: {
					discripAgId: this.givInfo.discrepancyAgencyId,
					givBoundaryName: this.givInfo.bdryName,
					givBoundaryCat: this.givInfo.bdryCate,
					customerCounties: [this.givInfo.county.name], // this.countyList.filter(c => c.isNeighbor).map(c => c.name), // this.givInfo.neighboringCounties,
					customerCentroid: this.givInfo.county.centroidStr,
					customerState: this.userService.customerInfo.givState,
					customerNguidPattern: this.givInfo.nguidPattern.layerType ? 2 : 1
				}
			};
			this.dialogRef.close(data);
		}
	}

	onSelectCounty() {
		if (this.givInfo.county) {
			this.givInfo.bdryName = this.givInfo.county.name;
			const county = this.countyList.find(c => c.name === this.givInfo.county.name);
			// if (!county.isNeighbor) {
			// 	county.isNeighbor = true;
			// }
			// this.givInfo.centroidLatlong = this.givInfo.county.centroidStr;
		} else {
			this.givInfo.bdryName = '';
			// this.givInfo.centroidLatlong = null;
		}
	}

	onPatternChange(e) {
		this.givInfo.nguidPattern = e;
	}

	private initGivBdryTypes() {
		// TODO!!!!!!!!

		this.givBdryCateList = this.agencyInfoService.givBdryCateList;
		this.givInfo.bdryCate = this.givBdryCateList[0].prop;
	}
	private async initCounties() {
		this.countyList = await this.agencyInfoService.getCounties();
		// const stateCode = this.userService.customerInfo.givState;
		// const countiesRsp = await this.nagService.getNagNamesStandard(2, stateCode, null, { pageNumber: 0 });
		// if (countiesRsp.data) {
		// 	this.countyList = countiesRsp.data.map(i => {
		// 		return {
		// 			name: i[this.attrIndexService.stnNameCol],
		// 			centroidStr: i[this.attrIndexService.centroidCol]
		// 		}
		// 	});
		// } else {
		// 	this.countyList = [];
		// }
	}
	async ngOnInit() {
		this.initGivBdryTypes()
		await this.initCounties();
	}

}
